.wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Reveal tooltip only when the button itself is hovered or focused */
.btn:hover + [role="tooltip"],
.btn:focus-visible + [role="tooltip"] {
  opacity: 1;
  pointer-events: auto;
}

.btn {
  composes: controlBtn from '../styles/controls.module.css';
}

.iconPause {
  display: none;
}

.playing .iconPlay {
  display: none;
}

.playing .iconPause {
  display: block;
}
